import { intl } from "LocaleWrapper";
import { Card } from "@cofano/cck";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import Apps from "@mui/icons-material/Apps";
import { DossierLink } from "utils/LinkUtils";
import { getCharterIcon } from "utils/charterUtils";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";
import { VoyagePurchaseCharterTabFragment } from "__generated__/view/voyages/graphql/voyage-info.fragments.generated";

interface VoyagePurchaseChartersProps {
	charters: NonNullable<VoyagePurchaseCharterTabFragment["purchaseCharters"]>;
}

const VoyagePurchaseChartersDetails = ({ charters }: VoyagePurchaseChartersProps) => {
	return (
		<Grid container spacing={2}>
			<Grid size={12}>
				<Card title={intl.formatMessage({ id: "CHARTERS" })} icon={<Apps />} disablePadding>
					<Grid container spacing={2}>
						<Grid size={12}>
							{charters.length > 0 ? (
								<Box p={2} pt={0}>
									{charters.map((charter, index) => (
										<Card
											key={charter.id}
											title={
												<Box sx={{ display: "flex", alignItems: "center" }}>
													<Box marginRight={1}>
														{getCharterIcon(charter.type, charter.subtype, "1x")}
													</Box>
													<Typography component="span" fontSize={14} fontWeight="bold">
														{intl.formatMessage({ id: "CHARTER" })} #{index + 1}
													</Typography>
												</Box>
											}
											subtitle={<DossierLink charter={charter} />}
											collapsable={false}
											color={getCharterTypeColor(charter.type, charter.subtype)}
										/>
									))}
								</Box>
							) :  (
								<Box p={2} sx={{ display: "flex", justifyContent: "center" }}>
									<Typography
										component="span"
										fontStyle="italic"
										fontSize="small">
										{intl.formatMessage({ id: "VOYAGE_CHARTERS_NOT_LINKED" })}
									</Typography>
								</Box>
							)}
						</Grid>
					</Grid>
				</Card>
			</Grid>
		</Grid>
	);
};

export default VoyagePurchaseChartersDetails;
